<template>
  <div class="head-page" style="padding-bottom: 50px;">
    <Header :title="$t('market.title')" />
    <van-tabs v-model="bType" @click="tochange">
      <van-tab
        v-for="(item, index) in tab"
        :title="item.currency_name"
        :name="item.id"
        :key="index"
      />
    </van-tabs>
    <van-tabs v-model="type" @click="toitemchange" v-show="tab1.length > 0">
      <van-tab :title="$t('market.all')" name="0" />
      <van-tab
        v-for="(item, index) in tab1"
        :title="item.currency_name"
        :name="item.id"
        :key="index"
      />
    </van-tabs>
    <div class="market-ranking-box">
      <div>
        <van-row>
          <van-col :span="11">
            <div class="table-head">{{ $t("home.name") }}</div>
          </van-col>
          <van-col :span="8">
            <div class="table-head">{{ $t("home.price") }}</div>
          </van-col>
          <van-col :span="5">
            <div class="table-head txt-right">{{ $t("home.risefall") }}</div>
          </van-col>
        </van-row>
        <van-row class="table-data-row" v-for="(item,index) in dataLst" :key="index" @click="toPage(item)">
          <van-col :span="11">
            <div class="table-name">
              <div class="name">
                {{ item.title.split('/')[0] }}<span>/{{ item.title.split('/')[1] }}</span>
                <p>24H {{ item.hamount }}</p>
              </div>
            </div>
          </van-col>
          <van-col :span="8">
            <div class="table-price">
              {{ item.close }}
              <p>$ {{ parseFloat(item.close).toFixed(2) }}</p>
            </div>
          </van-col>
          <van-col :span="5">
            <div
              class="table-rise-fall"
              :class="item.change.indexOf('+') != -1 ? 'rise' : 'fall'"
            >
              {{ item.change }}%
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  name: "MarketView",
  components: { Header, Footer },
  data() {
    return {
      bType: 0,
      type: 0,
      tab: [],
      tab1: [],
      dataLst: [],
      timer: null,
    };
  },
  mounted() {
    this.getTab();
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    toPage(item){
      this.$router.push(
        {
          name: "options",
          query: {
            currentSymbol: item.symbol,
            name:item.title,
          },
        },
        () => {}
      );
    },
    async getTab() {
      await this.$http({
        method: "post",
        url: "getAllCurrencyList",
      }).then((res) => {
        if (res && res.data && res.data.list) {
          this.tab = res.data.list;
          this.bType = this.tab[0].id;
          this.tochange(this.bType);
        }
      });
    },
    async getData() {
      await this.$http({
        method: "post",
        url: "getAllMarketList",
        data: { fid: this.bType, eid: this.type },
      }).then((res) => {
        if (res && res.data && res.data.list) this.dataLst = res.data.list;
      });
    },
    tochange(item) {
      this.tab1 = [];
      this.type = 0;
      this.tab.forEach((element) => {
        if (element.id == item && element.child && element.child.length > 0) {
          this.tab1 = element.child;
        }
      });
      this.resetData()
    },
    toitemchange(item) {
      this.type = item;
      this.resetData()
    },
    resetData() {
      if (this.timer) clearInterval(this.timer);
      this.getData();
      const that = this;
      this.$nextTick(() => {
        that.timer = setInterval(() => {
          that.getData();
        }, 10000);
      });
    },
  },
};
</script>

<style>
</style>
